import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '../reducer'

export const costCalculatorSelector = (state: AppState) => state.costCalculator

export const getCostCalculatorInputDataSelector = createSelector(
  costCalculatorSelector,
  costCalculatorState => costCalculatorState.inputData
)

export const getCostCalculatorOutputSelector = createSelector(
  costCalculatorSelector,
  costCalculatorState => costCalculatorState.outputData
)

export const getInsuranceCostReportSelector = createSelector(
  costCalculatorSelector,
  costCalculatorState => costCalculatorState.insuranceCostReport
)
